module.exports = __webpack_public_path__ + "img/31fc17a.png";